import HeadBanner from './headBanner'

export default HeadBanner
